import axios from "axios";
export default {
  namespaced: true,

  state: {
    predictions: [],
    prediction: null
  },

  getters: {
    predictions(state) {
      return state.predictions;
    },

    predictionNumber(state) {
      if (state.predictions && state.predictions.length > 0) {
        return state.predictions.length;
      } else {
        return;
      }
    },

    prediction(state) {
      return state.prediction;
    }
  },

  mutations: {
    SET_PREDICTIONS(state, predictions) {
      state.predictions = predictions;
    },
    SET_PREDICTION(state, prediction) {
      state.prediction = prediction;
    }
  },

  actions: {
    async getPredictions({ commit }) {
      try {
        let response = await axios.get("/api/predictions");
        commit("SET_PREDICTIONS", response.data.data);
      } catch (e) {
        commit("SET_PREDICTIONS", null);
      }
    },
    async getPredictionsss({ commit }, data) {
      try {
        let response = await axios.get(
          `/api/predictions?page=${data.page}&limit=${data.limit}`
        );
        commit("SET_PREDICTIONS", response.data.data);
      } catch (e) {
        commit("SET_PREDICTIONS", null);
      }
    },
    async getPrediction({ commit }, data) {
      try {
        let response = await axios.get(`/api/predictions?_id=${data}`);
        commit("SET_PREDICTION", response.data.data[0]);
      } catch (e) {
        commit("SET_PREDICTION", null);
      }
    },
    async clearPrediction({ commit }) {
      commit("SET_PREDICTION", null);
    },
    async clearPredictions({ commit }) {
      commit("SET_PREDICTIONS", null);
    }
  }
};
